import { React } from 'react';
import styled from '@emotion/styled';
import { Modal } from 'antd';

const CustomModalTemplate = props => (
  <Modal {...props} zIndex={1300}>
    {props.children}
  </Modal>
);

export const CustomModal = styled(CustomModalTemplate)`
  height: 100vh;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  transition: width 0.5s;
  padding: 0;
  & .ant-modal-body {
    padding: 0;
    border-radius: 0;
    height: 100%;
  }
`;

export const CloseButtonContainer = styled.div`
  width: 100%;
  position: relative;
  & > span {
    position: absolute;
    margin: 15px;
    right: 0;
    top: 0;
  }
`;

export const PopUpBody = styled.div`
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3rem 1.8rem;
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const LogoWrapperInner = styled.div`
  width: 120px;
`;

export const MessageBody = styled.span`
  white-space: pre-line;
  margin: 15px 0px;
  text-align: center;
  line-height: 2;
  font-size: 16px;
  color: #27344c;
`;

export const TextButton = styled.button`
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  color: red;
  font-family: 'Heebo';
  font-size: 16px;
  font-weight: 500;
  line-height: 1.67;

  &:hover {
    text-decoration: underline;
  }
`;
